import { render, staticRenderFns } from "./query-view.vue?vue&type=template&id=8832a588&lang=pug"
import script from "./query-view.vue?vue&type=script&lang=js"
export * from "./query-view.vue?vue&type=script&lang=js"
import style0 from "./query-view.vue?vue&type=style&index=0&id=8832a588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports